"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _reactRouter = require("react-router");

var _queryStringForAll = _interopRequireDefault(require("query-string-for-all"));

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _blocks = require("@bueno/blocks");

var _SiteMenu = _interopRequireDefault(require("../../containers/SiteMenu"));

var _UserMenu = _interopRequireDefault(require("./components/UserMenu"));

var _PrimaryNav = require("./components/PrimaryNav");

var _getClientRoutes = require("./getClientRoutes");

var _tenant = require("../../utils/tenant");

var _hooks = require("../../context/feature-flags/hooks");

/* eslint-disable no-eq-null */
const Chrome = _styledComponents.default.div`
  min-width: 1200px;
  color: ${_blocks.color.theme.typography.ink};
`;
const PrimaryNavContainer = _styledComponents.default.nav`
  height: 52px;
  display: flex;
  flex: 0 0 auto;
  flex-wrap: nowrap;
  align-items: center;
  justify-content: space-between;
  gap: ${_blocks.spacing.default};
  padding: 0px ${_blocks.spacing.default};
  height: 52px;
  /* neutral 12 */
  background-color: hsl(206, 24%, 9%);
`;

function AppChrome(props) {
  const updateQSSites = selectedSites => {
    const {
      history
    } = props;

    const qs = _queryStringForAll.default.parse(history.location.search);

    const sites = selectedSites.join(',');

    const stringified = _queryStringForAll.default.stringify({ ...qs,
      sites
    });

    history.replace({
      search: stringified
    });
  };

  const {
    appReady,
    user
  } = props;
  return /*#__PURE__*/_react.default.createElement(Chrome, {
    className: "AppChrome"
  }, (user === null || user === void 0 ? void 0 : user.tenantId) != null && /*#__PURE__*/_react.default.createElement(Navigation, {
    loggedIn: appReady,
    user: user,
    updateQSSites: updateQSSites
  }));
}

function Navigation({
  loggedIn,
  user,
  updateQSSites
}) {
  const apertureBaseUrl = (0, _tenant.useApertureUrl)();
  const enableBuenoLabs = (0, _hooks.useFeatureFlag)('enable-bueno-labs');
  const clientRoutes = (0, _getClientRoutes.getClientRoutes)(user || {
    access: []
  }, enableBuenoLabs, apertureBaseUrl);
  const {
    appLinks
  } = clientRoutes;
  return /*#__PURE__*/_react.default.createElement(PrimaryNavContainer, null, user && /*#__PURE__*/_react.default.createElement(_SiteMenu.default, {
    onSitesUpdate: updateQSSites
  }), appLinks.length > 0 && /*#__PURE__*/_react.default.createElement(_PrimaryNav.PrimaryNav, {
    links: appLinks,
    userAccess: user === null || user === void 0 ? void 0 : user.access
  }), /*#__PURE__*/_react.default.createElement(_UserMenu.default, {
    className: "UserMenu",
    clientRoutes: clientRoutes,
    loggedIn: loggedIn
  }));
}

var _default = (0, _reactRouter.withRouter)(AppChrome);

exports.default = _default;
module.exports = exports.default;